import { ColumnsWidths } from '../../utils';

/* eslint-disable @typescript-eslint/naming-convention */
export const getColumnsWidths = (): ColumnsWidths[] => ([
  { 'Company name': 155 }, { Registration: 100 }, { Industry: 130 }, { Description: 700 }, { Website: 160 },
]);
/* eslint-enable @typescript-eslint/naming-convention */
